module.exports = __webpack_public_path__ + "img/sintesis.d40c76e4.svg";